import QBreadcrumbs from './src/QBreadcrumbs.vue';

/* istanbul ignore next */
QBreadcrumbs.install = function(Vue) {
  Vue.component(QBreadcrumbs.name, QBreadcrumbs);
};

export default QBreadcrumbs;
